import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { DealerOfferParams } from '../../reducers/types';
import { selectDealerOfferParams } from '../../selectors/meta';

type DealerOfferListenerProps = {
  onDealerOfferParamsUpdate: (params: DealerOfferParams) => void;
};

export const DealerOfferListener: FC<
  PropsWithChildren<DealerOfferListenerProps>
> = ({ children, onDealerOfferParamsUpdate }) => {
  const dealerOfferParams = useSelector(selectDealerOfferParams);

  useEffect(
    () => dealerOfferParams && onDealerOfferParamsUpdate(dealerOfferParams),
    [dealerOfferParams],
  );

  return <>{children}</>;
};
